import React from 'react';
import { mergeClassNames } from '../../../../../core/style';
import { ToggleSwitchButton } from '../../../../../core/components/toggle';

interface ButtonToggleProps {
  checked: boolean;
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
  id: string;
  onClick: VoidFunction;
}

const ButtonToggle = ({
  checked,
  children,
  className = '',
  disabled = false,
  id,
  onClick,
}: ButtonToggleProps): JSX.Element => {
  const containerClassName = mergeClassNames([{ className: 'mw-100' }, { className }]);
  return (
    <div className={containerClassName}>
      <ToggleSwitchButton checked={checked} disabled={disabled} id={id} onClick={onClick}>
        {children}
      </ToggleSwitchButton>
    </div>
  );
};

export default ButtonToggle;
